import { TrendingDown, TrendingUp } from 'lucide-react';
import React from 'react'

const MetricCard = ({ icon, title, value, change, period }) => {
  const isPositive = change >= 0;
  const changeColor = isPositive ? 'text-green-500' : 'text-red-500';

  return (
    <div className="p-4 bg-white rounded-lg shadow-sm">
      <div className="flex items-center gap-1 mb-2">
        {icon && (
          <div className="p-2 text-orange-500 bg-orange-100 rounded-full">
            {icon}
          </div>
        )}
        <h3 className="text-[12px] font-medium text-gray-600">{title}</h3>
      </div>
      
      <div className="flex items-center flex-col gap-3">
        <span className="text-3xl font-semibold text-gray-900">{value}</span>
        <div className="flex items-center gap-1 mb-1">
          <span className={`text-sm font-medium ${changeColor} flex items-center gap-1`}>
            {isPositive ? <TrendingUp size={16} /> : <TrendingDown size={16} />}
            {isPositive ? `+${change}%` : `${change}%`}
          </span>
          <span className="text-sm text-gray-500">
            {period}
          </span>
        </div>
      </div>
    </div>
  )
}

export default MetricCard